import * as _ from 'lodash';

import { receiverImgName } from 'shared/receivers/receivers-helpers';


const checkboxWidth = 55;
// const receiverWidth = '184px';
const nameWidth = 125;
const cityWidth = 140;
const stateWidth = 85;
const zipWidth = 70;
const flagWidth = 50;

// for calculating receiver & tags cols
const allColWidth = checkboxWidth + nameWidth * 2 + cityWidth + stateWidth + zipWidth + flagWidth * 2;

/* eslint-disable */
const restColWidth = `calc(50% - ${allColWidth/2}px)`;
/* eslint-enable */

export const columns: any = [
  {
    title: 'select-all-btn',
    width: `${checkboxWidth}px`,
    active: false,
    col: 'select-btn',
    showPermissions: ['admin', 'catalog-edit', 'repository'],
  },
  {
    title: 'Receiver',
    width: restColWidth,
    sortable: true,
    sort: 'desc',
    sortName: 'name',
    active: false,
    col: 'name',
    type: 'html',
    titleLeftPadding: '51px',
    handleClick: true,
    truncate: true,
    ghostValue: (row: any) => {
      return row.name;
    },
    data: receiverImgName,
  },
  {
    title: 'Tags',
    width: restColWidth,
    sortable: false,
    active: false,
    col: 'tags',
    truncate: true,
    data: (row: any) => {
      return _.join(row.tags, ', ');
    },
  },
  {
    title: 'First Name',
    width: `${nameWidth}px`,
    sortable: true,
    sort: 'desc',
    sortName: 'contactFirstName',
    active: false,
    col: 'contact_first_name',
    truncate: true,
  },
  {
    title: 'Last Name',
    width: `${nameWidth}px`,
    sortable: true,
    sort: 'desc',
    sortName: 'contactLastName',
    active: false,
    col: 'contact_last_name',
    truncate: true,
  },
  {
    title: 'City',
    width: `${cityWidth}px`,
    sortable: true,
    sort: 'desc',
    sortName: 'city',
    active: false,
    col: 'city',
    truncate: true,
  },
  {
    title: 'State',
    width: `${stateWidth}px`,
    sortable: true,
    sort: 'desc',
    sortName: 'state',
    active: false,
    col: 'state',
    truncate: true,
  },
  {
    title: 'Zip',
    width: `${zipWidth}px`,
    sortable: true,
    sort: 'desc',
    sortName: 'zipCode',
    active: false,
    col: 'zip_code',
    truncate: true,
  },
  {
    title: 'DNS',
    width: `${flagWidth}px`,
    sortable: true,
    sort: 'desc',
    sortName: 'doNotSell',
    active: false,
    col: 'do_not_sell',
    type: 'icon',
    icon: 'dns-icon',
    showTitle: true,
  },
  {
    title: 'Status',
    width: `${flagWidth}px`,
    sortable: true,
    sort: 'desc',
    sortName: 'readyToReceive',
    active: false,
    col: 'ready_to_receive',
    type: 'icon',
    icon: 'ready-to-receive-icon',
    showTitle: true,
  },
];
